import { render, staticRenderFns } from "./ReconfigureMailComplete.vue?vue&type=template&id=12e84412&scoped=true&lang=pug&"
import script from "./ReconfigureMailComplete.vue?vue&type=script&lang=ts&"
export * from "./ReconfigureMailComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e84412",
  null
  
)

export default component.exports